import { writable } from 'svelte/store';

export const storeDevice = writable({});
export const storeShopifyCart = writable(null);
export const storeShopifyProducts = writable(null);

export const storeVideo = writable([
	// Auto Motive
	{
		id: `1895399`,
		cat: [`Automotive`],
		title: `ZMAX30`,
		description: ``,
		date: `08/19/19`,
		cover: `/lib-legacy/images/video/a8db2ca2-a653-bf3b-4e485fa3df589294_160x90.jpg`,
		ytId: `uAL4CsgLom8`,
	},
	{
		id: `1895377`,
		cat: [`Automotive`],
		title: `zMAX delivers a "longer stretch of road"`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `08/19/19`,
		cover: `/lib-legacy/images/video/a8c5fe32-077b-fe90-2104225db8391f88_160x90.webp`,
		ytId: `HjslZ1TgDx4`,
	},
	{
		id: `1895358`,
		cat: [`Automotive`],
		title: `DriversTalk Radio talks truth about zMAX`,
		description: `In a class its own, zMAX is not an additive, but a micro-lubricant that uses the fluids in your vehicle to get to internal parts where it soaks into metal to disperse harmful carbon build-up. Other products change the viscosity of the oil. zMAX doesn't need to do that. It works all on its own. That's why Carroll Shelby used it in his cars!`,
		date: `08/19/19`,
		cover: `/lib-legacy/images/video/a899d345-b96b-5170-a570f99f62429fee_160x90.jpg`,
		ytId: `6m04FtFqRsU`,
	},
	{
		id: `1840081`,
		cat: [`Automotive`],
		title: `NSS hype`,
		description: `zMAX is a proud sponsor of Bobby Measmer, Jr. and Hughes Motorsports. Look for him at all the Whelen Modified Series races.`,
		date: `11/05/18`,
		cover: `/lib-legacy/images/video/f7c47110-bdba-1c88-9d4a12997b605e40_160x90.webp`,
		ytId: `Q8CTgJS9rvs`,
	},
	{
		id: `1830910`,
		cat: [`Automotive`],
		title: `Customers love zMAX`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `09/25/18`,
		cover: `/lib-legacy/images/video/83185c1a-f946-f055-59f6deb1c7065c65_160x90.jpg`,
		ytId: `MJoSRr5t5ks`,
	},
	{
		id: `1831003`,
		cat: [`Automotive`],
		title: `It starts with zMAX Micro-lubricant!`,
		description: `zMAX Micro-lubricant is not your typical additive...it starts with micro-molecules that use the fluids in your vehicle to reach internal parts.`,
		date: `09/25/18`,
		cover: `/lib-legacy/images/video/ab1888dc-ca15-91f8-fd7881313beb5947_160x90.jpg`,
		ytId: `vH4xEoYYGOs`,
	},
	{
		id: `1831000`,
		cat: [`Automotive`],
		title: `The Science Behind zMAX`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `09/25/18`,
		cover: `/lib-legacy/images/video/ab066cef-0e1b-b2b6-c36f1d5a625f3a5d_160x90.webp`,
		ytId: `pAyXPCdrNiY`,
	},
	{
		id: `1830999`,
		cat: [`Automotive`],
		title: `Why You Need zMAX`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `09/25/18`,
		cover: `/lib-legacy/images/video/aafc67a0-bb53-e1d5-56d6917e21920d04_160x90.webp`,
		ytId: `eqn73E5km5o`,
	},
	{
		id: `1831118`,
		cat: [`Automotive`],
		title: `zMAX for engine and fuel system`,
		description: `The science behind how zMAX works.`,
		date: `09/15/18`,
		cover: `/lib-legacy/images/video/db3bc7a8-a812-9298-76cc8f0a124c87e0_160x90.webp`,
		ytId: `AHAp1vmlw8Q`,
	},
	{
		id: `1832350`,
		cat: [`Automotive`],
		title: `zMAX for Generations`,
		description: `Our customers truly believe in the benefits gained by using zMAX. So much so, they pass on using zMAX to the next generation.`,
		date: `07/03/18`,
		cover: `/lib-legacy/images/video/1156c507-ff5d-5067-21d00374c164ba33_160x90.jpg`,
		ytId: `pVpMDWRe2O8`,
	},
	{
		id: `1841750`,
		cat: [`Automotive`],
		title: `zMAX - The ONE Product your vehicle needs`,
		description: `Help your vehicle get the performance it deserves with zMAX Micro-lubricant. Easy to use, just add zMAX to your oil and fuel for extended engine life, improved performance, and reduced emissions.`,
		date: `06/24/18`,
		cover: `/lib-legacy/images/video/875284a2-ea07-fe47-318491b018f8dd6f_160x90.jpg`,
		ytId: `jWJdNS71w9U`,
	},
	{
		id: `1895409`,
		cat: [`Automotive`],
		title: `Shelby has always been a zMAX user.`,
		description: `Carroll Shelby used zMAX in all of his other vehicles.`,
		date: `10/25/17`,
		cover: `/lib-legacy/images/video/a8e486bb-954f-8270-c2abaa61cd258d31_160x90.jpg`,
		ytId: `4dYC_DmFEB4`,
	},
	{
		id: `1895427`,
		cat: [`Automotive`],
		title: `TruckU talks cleaning your engine with zMAX`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `06/11/17`,
		cover: `/lib-legacy/images/video/ae46530d-9568-c1f2-1d623198b8414c42_160x90.jpg`,
		ytId: `NXN4visMynE`,
	},
	{
		id: `1895413`,
		cat: [`Automotive`],
		title: `TGG1201 zMAX TechTip`,
		description: `Two Guys Garage tells how to store and save your engine when not in use.`,
		date: `06/04/17`,
		cover: `/lib-legacy/images/video/a923fa65-c955-7977-349fb2761049b395_160x90.jpg`,
		ytId: `u7EZ_dSLgJE`,
	},
	{
		id: `1895419`,
		cat: [`Automotive`],
		title: `Performance TV talks zMAX`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `05/25/17`,
		cover: `/lib-legacy/images/video/aa9617a4-b013-fd8c-89c268cf4bab4a75_160x90.jpg`,
		ytId: `ogxYVX4W_YU`,
	},
	{
		id: `1895415`,
		cat: [`Automotive`],
		title: `zMAX for boats`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions. For use in gas or diesel engines.`,
		date: `04/12/17`,
		cover: `/lib-legacy/images/video/a9e6f557-9656-4de5-6c3144fc7d7dd0e5_160x90.jpg`,
		ytId: `H052CihH_Tc`,
	},
	{
		id: `1895420`,
		cat: [`Automotive`],
		title: `zMAX for new and used vehicles`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `03/19/17`,
		cover: `/lib-legacy/images/video/aa9f2237-d3ea-5c4d-091e17522154564d_160x90.jpg`,
		ytId: `JuPBjlkcsto`,
	},
	{
		id: `1895426`,
		cat: [`Automotive`],
		title: `TruckU talks fuel systems with zMAX Micro-lubricant`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `02/19/17`,
		cover: `/lib-legacy/images/video/ae385772-9020-0f01-e92f2678fd949103_160x90.jpg`,
		ytId: `4U9gWs-sdGY`,
	},
	{
		id: `1895425`,
		cat: [`Automotive`],
		title: `Dirty combustion vs zMAX Micro-lubricant`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `01/19/17`,
		cover: `/lib-legacy/images/video/ae2d2289-cc14-a628-70f0caf7f86d25f8_160x90.webp`,
		ytId: `m8DZoaCyzcw`,
	},
	{
		id: `1895429`,
		cat: [`Automotive`],
		title: `TruckU tests zMAX Micro-lubricant`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `12/19/16`,
		cover: `/lib-legacy/images/video/ae6288ec-93a7-4de4-ce4b4f35c16d4575_160x90.webp`,
		ytId: `m8DZoaCyzcw`,
	},
	{
		id: `1895411`,
		cat: [`Automotive`],
		title: `Cleaning engine with zMAX is this easy!`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `12/06/16`,
		cover: `/lib-legacy/images/video/a8f70f95-f7a0-ae16-26f811e6bc5ebb42_160x90.webp`,
		ytId: `xXQZdztSN5g`,
	},
	{
		id: `1895410`,
		cat: [`Automotive`],
		title: `zMAX & Truck U Tip: Automatic Transmission`,
		description: ``,
		date: `11/30/16`,
		cover: `/lib-legacy/images/video/a8efcd94-0b40-0e9a-4f9099bf106db441_160x90.jpg`,
		ytId: `zcNs-Fc8V_Y`,
	},
	{
		id: `1895424`,
		cat: [`Automotive`],
		title: `Valve cleaning with zMAX Micro-lubricant`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `08/19/16`,
		cover: `/lib-legacy/images/video/ae22a748-b911-1afb-12b93df389105352_160x90.jpg`,
		ytId: `wO4qMOAxksQ`,
	},
	{
		id: `1895428`,
		cat: [`Automotive`],
		title: `TruckU discusses a new engine and zMAX Micro-lubricant`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, increase horsepower, reduce emissions and increase gas mileage. For use in automatic or manual transmissions; gas or diesel engines.`,
		date: `08/07/16`,
		cover: `/lib-legacy/images/video/ae5823a3-ca15-4873-9f2bac2f3663c128_160x90.jpg`,
		ytId: `BMo4LP7yPdA`,
	},
	{
		id: `1895359`,
		cat: [`Automotive`],
		title: `zMAX Micro-lubricant for Turbo Chargers`,
		description: `As seen on TruckU TV. Get the power you want and protection you need with zMAX Micro-lubricant. As it reduces build-up, zMAX helps improve performance, reduce emissions and extend engine life. Keeping your turbo charger free of harmful build-up will help it run more efficiently.`,
		date: `08/19/15`,
		cover: `/lib-legacy/images/video/a89e0d76-9cff-826f-3b490319cc3a47fe_160x90.jpg`,
		ytId: `P111UVm1Dz8`,
	},
	// Small Engine
	{
		id: `1830923`,
		cat: [`Small Engine`],
		title: `zMAX for your watercraft`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This allows zMAX to extend engine life, improve performance, protect against rust and corrosion, increase horsepower and reduce emissions. Use before and after each season.`,
		date: `03/24/17`,
		cover: `/lib-legacy/images/video/862b1f28-9fd7-dd04-5e000cab9d18a9ba_160x90.jpg`,
		ytId: `_o6A94wHxkY`,
	},
	{
		id: `1831004`,
		cat: [`Small Engine`],
		title: `zMAX Micro-lubricant for use in 2-cycle engines`,
		description: `zMAX Micro-lubricant instructions for 2-cycle engines.`,
		date: `09/25/15`,
		cover: `/lib-legacy/images/video/ab23209a-c39d-290c-b4ee2d5b1b075b15_160x90.jpg`,
		ytId: `-9OFdZuXLjo`,
	},
	{
		id: `1831005`,
		cat: [`Small Engine`],
		title: `zMAX Micro-lubricant use in 4-Cycle engines`,
		description: `How to use zMAX in 4-cycle engines.`,
		date: `09/15/15`,
		cover: `/lib-legacy/images/video/ab277e42-a12d-c2cb-7e45a2f4014457b6_160x90.jpg`,
		ytId: `jD0hTZw3UXI`,
	},
	// Firearms
	{
		id: `1902354`,
		cat: [`Firearms`],
		title: `Are you ready for hunting season?`,
		description: `Clean, lube and protect your firearms so you're ready when hunting season begins. zMAX Bolt Lube and zMAX Bore Cleaner and Conditioner are safe to use on all firearms. zMAX disperses carbon build-up and soaks into metal to provide extended lubrication.`,
		date: `09/18/19`,
		cover: `/lib-legacy/images/video/ba4a1c0c-aad2-4100-11bb34e2fa725da5_160x90.jpg`,
		ytId: `L28j2qXFQTc`,
	},
	{
		id: `1902355`,
		cat: [`Firearms`],
		title: `David Denies Bird Hunting Lodge & zMAX`,
		description: `David Denies Hunting Lodge reaps the benefits of using zMAX Bolt Lube and zMAX Bore Cleaner and Conditioner. Watch how`,
		date: `08/12/18`,
		cover: `/lib-legacy/images/video/ba52c6c5-aaa5-a6f4-76852f50b5c3ab3c_160x90.jpg`,
		ytId: `NMEB7_LESOo`,
	},
	{
		id: `1830913`,
		cat: [`Firearms`],
		title: `zMAX is great for firearms`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. This helps reduce build-up, clean and condition firearms. Does not gum up. Safe for all firearms.`,
		date: `07/27/18`,
		cover: `/lib-legacy/images/video/83e49249-f1fe-0d1f-0225151cce981b4e_160x90.jpg`,
		ytId: `_BQZlUu61uQ`,
	},
	{
		id: `1831001`,
		cat: [`Firearms`],
		title: `Actual zMAX testing on firearms`,
		description: `Boltlube and Bore Cleaner and Conditoner. Does not gum up. Clean, conditions and protects firearms. Perfect for frequent firing or in storage. Safe for all firearms.`,
		date: `04/25/18`,
		cover: `//www.zmax.com/video/youtube/ab0e05a1-93b7-f1f5-00063c076e31eb01_160x90.jpg`,
		ytId: `QuxQf3FOwng`,
	},
	// Aviation
	{
		id: `1830997`,
		cat: [`Aviation`],
		title: `Sean Tucker never flies without AVBLEND`,
		description: `Hall of Fame aerobatic pilot Sean Tucker always flies with AVBLEND.`,
		date: `9/25/18`,
		cover: `/lib-legacy/images/video/aade3a7c-9da9-92a4-fe78daa24e51f216_160x90.webp`,
		ytId: `bwYWMwmEPzs`,
	},
	{
		id: `1830925`,
		cat: [`Aviation`],
		title: `zMAX for Planes, Trains, Automobiles`,
		description: `No matter how you travel, be covered by zMAX Micro-lubricant as it soaks into metal to help reduce harmful carbon deposits.`,
		date: `9/24/18`,
		cover: `/lib-legacy/images/video/863a2176-d970-6cca-b8d0507a26463225_160x90.jpg`,
		ytId: `ve7B5-uzLMM`,
	},
	{
		id: `1830998`,
		cat: [`Aviation`],
		title: `zMAX Customer Stories`,
		description: `From Carroll Shelby to Sean Tucker to the everyday driver, our customers know zMAX works.`,
		date: `06/25/18`,
		cover: `/lib-legacy/images/video/aaefa467-0be9-a4b0-c08fd0b841fd159d_160x90.jpg`,
		ytId: `qZD7FuSTnhA`,
	},
	{
		id: ``,
		cat: [`Aviation`],
		title: `AVBLEND and zMAX Firearm Formulas`,
		description: `zMAX has something for any piston engine, even small piston-driven aircraft. AVBLEND is FAA approved for use in your small plane.`,
		date: `06/19/16`,
		cover: `/lib-legacy/images/video/aa340f25-b0f1-5169-e49d78d8d33b4d32_160x90.webp`,
		ytId: `sn364QnTxHc`,
	},
	// Locomotive
	{
		id: `1831121`,
		cat: [`Locomotive`],
		title: `zMAX Micro-lubricant for Locomotives`,
		description: `zMAX Micro-lubricant soaks into metal to help reduce harmful carbon deposits. Protect your engine and get the power you need!`,
		date: `1/26/18`,
		cover: `/lib-legacy/images/video/dbe3c391-a8f8-a724-9a20a7cd1e7cd335_160x90.jpg`,
		ytId: `u9KkzqGa_Ic`,
	},
	// Power Sports
	{
		id: `190368`,
		cat: [`Power Sports`],
		title: `STORR's 2019 Baja 500 HIghlights`,
		description: `Join STORR as they storm the border and take on the mighty Baja 500 (2019). Although this years race didn't lead to the victory we wanted, our perseverance and fight made for a great journey for the team. #BajaWinsAgain Purchase Shock Therapy products direct at www.ShockTherapyst.com Follow STORR (Shock Therapy Off Road Racing): Instagram @ShockTherapyOffRoadRacing Facebook #STORR`,
		date: `10/03/19`,
		cover: `/lib-legacy/images/video/b51ece5b-d88d-4598-12197c94e8fbcec5_160x90.jpg`,
		ytId: `j_7OX-oMykI`,
	},
	{
		id: `1903687`,
		cat: [`Power Sports`],
		title: `Nathan at Club MX loves zMAX Silicone Spray!`,
		description: `zMAX Silicone Spray cleans and shines, restoring a glossy finish. Nathan uses it on this ClubMX bike before and after a race.`,
		date: `10/03/19`,
		cover: `/lib-legacy/images/video/b4f23be1-e713-25d7-a6cae2e2c4eeaf64_160x90.jpg`,
		ytId: `UKrhHmpuVE8`,
	},
	{
		id: `1903686`,
		cat: [`Power Sports`],
		title: `zMAX and motocross racing`,
		description: `zMAX is used by racers to help clean, lube and protect their motorcycles.`,
		date: `10/03/19`,
		cover: `/lib-legacy/images/video/b4ef5c24-cddb-8030-644eec46c28dbae1_160x90.jpg`,
		ytId: `ygibisDpCmc`,
	},
	{
		id: `1903685`,
		cat: [`Power Sports`],
		title: `Ryan Cibulski Arvada skatepark day edit`,
		description: `Stopped at Ryan Cibulski local park in Arvada Colorado for a evening session Ryan is a tiresliding machine with style and amplitude to match`,
		date: `10/03/19`,
		cover: `/lib-legacy/images/video/b4e6e7aa-9e2f-93ca-29b9179947442c77_160x90.jpg`,
		ytId: `bI_PxYMehMs`,
	}
]);